import { QueryResult } from "@/api/utils/types"
import { SoDataTableHeader } from "@/types/components/SoDataTable"
import { SoExportCsvButtonData } from "@/components/dataTable/SoExportCsvButton.vue"
import dayjs from "dayjs"
import { ComplaintQueryResult } from "@/services/operations/ComplaintService"
import { allHeaders } from "@/views/operations/complaints/opsComplaintConfig"
import { IComplaint } from "@/models/complaint/complaint.types"
import { Complaint } from "@/api/hasura/generated/graphql"
import { yesNo } from "@/helpers/stringHelpers"

interface IComplaintCSVExporter {
  getConfig: () => {
    data: SoExportCsvButtonData
    headers: SoDataTableHeader[]
    fileName: () => string
  }
}

export class ComplaintCSVExporter implements IComplaintCSVExporter {
  private exportQuery: QueryResult<ComplaintQueryResult> | null

  constructor(exportQuery: QueryResult<ComplaintQueryResult> | null) {
    this.exportQuery = exportQuery
  }

  public getConfig() {
    return {
      data: this.parseDataForCSV(),
      headers: allHeaders,
      fileName: this.getFilename,
    }
  }

  private parseDataForCSV(): SoExportCsvButtonData {
    if (!this.exportQuery) return { isLoading: false, items: [] }
    const modelToCSVContent = (complaint: IComplaint) =>
      allHeaders.reduce((acc, header) => {
        acc[header.key] = this.handleObjectMapping(complaint, header)
        return acc
      }, {})

    return {
      isLoading: this.exportQuery.isFetching,
      items: this.exportQuery.data?.records.map(modelToCSVContent) ?? [],
    }
  }

  private handleObjectMapping(
    complaint: IComplaint,
    header: SoDataTableHeader<keyof IComplaint, keyof Complaint>,
  ) {
    const value = complaint[header.key]
    if (typeof value === "object" && "text" in value) {
      return value.text
    }
    if (typeof value === "object" && "props" in value) {
      return value.props.text
    }
    if (typeof value === "boolean") {
      return yesNo(value)
    }

    return value
  }

  private getFilename = (): string => {
    return `ops-complaints-results-${dayjs().toISOString()}.csv`
  }
}
